import { defineMessages } from 'react-intl';

export default defineMessages({
  genericName: {
    id: 'Generic Name:',
    defaultMessage: 'Generic Name:',
  },
  commercialName: {
    id: 'Commercial Name:',
    defaultMessage: 'Commercial Name:',
  },
  typeDrug: {
    id: 'Type of drug:',
    defaultMessage: 'Type of drug:',
  },
  routeAdministration: {
    id: 'Route(s) of Administration:',
    defaultMessage: 'Route(s) of Administration:',
  },
  alertsComposition: {
    id: 'Alerts by composition:',
    defaultMessage: 'Alerts by composition:',
  },
  relatedDiseaseTitle: {
    id: 'Drug related to the treatment of:',
    defaultMessage: 'Drug related to the treatment of:',
  },
  otherDrugs: {
    id: 'Other drugs',
    defaultMessage: 'Other drugs',
  }
});
